import React, { useState, useCallback, useMemo } from 'react';
import DashboardTabs from '@components/common/Dashboard/DashboardTabs';
import { Loading } from '@components/common';
import useGetSavedDashboardsList from './useGetSavedDashboardsList';
import DashboardTable from './components/DashboardTable';
import DashboardColumns from './components/DashboardColumns';
import DashboardTypesTabs from './components/DashboardTypesTabs';
import { PRIVATE_SAVED_DASHBOARDS_KEY, tabList } from './utils';
import { Wrapper } from './styled';
import { Input } from 'antd';
import { useSearch } from '@components/common/Table/hooks';
import { debounce } from 'lodash';

const Content = () => {
  const [activeTab, setActiveTab] = useState(PRIVATE_SAVED_DASHBOARDS_KEY);

  const columns = useMemo(() => DashboardColumns[activeTab], [DashboardColumns, activeTab]);
  const { data, isLoading } = useGetSavedDashboardsList({ dashboardTabKey: activeTab });

  const multiColumnSearch = ({ searchText, data }) => {
    const filteredData =
      data &&
      data.filter(
        (item) =>
          item.name.toLowerCase().includes(searchText.toLowerCase()) ||
          item.createdBy.toLowerCase().includes(searchText.toLowerCase()),
      );
    return filteredData;
  };

  const { filteredRows, onSearch } = useSearch({
    data,
    columnKey: 'name',
    searchFn: multiColumnSearch,
  });

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  const debouncedOnSearch = useMemo(() => debounce(onSearch, 200), [onSearch]);

  const { Search } = Input;

  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      debouncedOnSearch(value);
    },
    [debouncedOnSearch],
  );

  return (
    <Wrapper>
      <DashboardTabs id="saved_dashboards" />
      <DashboardTypesTabs
        items={tabList}
        onChange={handleTabChange}
        tabBarExtraContent={
          <div style={{ display: 'flex' }}>
            <Search
              placeholder="Search by dashboard name or created by user"
              enterButton
              onChange={handleChange}
              onSearch={onSearch}
            />
            <div style={{ width: '5px' }} />
          </div>
        }
      />
      {isLoading ? <Loading /> : <DashboardTable dashboards={filteredRows} columns={columns} />}
    </Wrapper>
  );
};

export default Content;
